<template>
  <div class="text-center">
    <v-dialog v-model="necessaryDialog" persistent width="500">
      <v-card>
        <v-card-title> FOLLOW-UP INFO </v-card-title>
        <v-card-text>
          <datetime
            placeholder="Click to Pick date and time"
            class="datetime-style"
            type="datetime"
            v-model="followup.datetime"
            use12-hour
          ></datetime>
          <v-textarea
            label="Description"
            v-model="followup.description"
            rows="3"
          ></v-textarea>
          <v-select
            v-model="followup.priority"
            :items="priorities"
            item-text="value"
            item-value="key"
            menu-props="auto"
            label="Priority"
            required
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn @click="skipFollowup" color="red" text>Skip</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="followup.id"
            @click="updateFollowup"
            :disabled="!this.followup.datetime"
            color="green"
            text
            >Update</v-btn
          >
          <v-btn
            v-else
            @click="createFollowup"
            color="green"
            :disabled="!this.followup.datetime"
            text
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "NecessaryFollowupDialog",
  props: ["lead_id", "user_id"],
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
      loadFollowups: "followups/loadFollowups",
    }),
    ...mapMutations({
      SET_NECESSARY_DIALOG: "followups/SET_NECESSARY_DIALOG",
      SET_UNCOMPLETED_LEAD: "auth/SET_UNCOMPLETED_LEAD",
    }),
    createFollowup() {
      this.$axios
        .post("/followup/create", {
          user_id: this.user_id,
          lead_id: this.lead_id,
          datetime: this.followup.datetime,
          priority: this.followup.priority,
          description: this.followup.description,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          if (this.necessaryDialog) {
            this.$axios
              .patch(`/agents/${this.user_id}/completed_lead`)
              .then((res) => {
                this.showHandlerSnackbar({
                  color: res.data.status,
                  text: res.data.message,
                  show: true,
                });
              })
              .catch((err) => {
                this.showHandlerSnackbar({
                  color: err.response.data.status,
                  text: err.response.data.message,
                  show: true,
                });
              });
            this.SET_UNCOMPLETED_LEAD(null);
            this.SET_NECESSARY_DIALOG(false);
          }
        })
        .catch((err) => {
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          });
        });
    },
    updateFollowup() {
      this.$axios
        .post("/followup/update", {
          id: this.followup.id,
          followup: {
            datetime: this.followup.datetime,
            description: this.followup.description,
            priority: this.followup.priority,
          },
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          if (this.necessaryDialog) {
            this.$axios
              .patch(`/agents/${this.user_id}/completed_lead`)
              .then((res) => {
                this.showHandlerSnackbar({
                  color: res.data.status,
                  text: res.data.message,
                  show: true,
                });
              })
              .catch((err) => {
                this.showHandlerSnackbar({
                  color: err.response.status,
                  text: err.response.message,
                  show: true,
                });
              });
            this.SET_UNCOMPLETED_LEAD(null);
            this.SET_NECESSARY_DIALOG(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    skipFollowup() {
      this.$axios
        .patch(`/agents/${this.user_id}/completed_lead`)
        .then((res) => {
          this.SET_UNCOMPLETED_LEAD(null);
          this.SET_NECESSARY_DIALOG(false);
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((err) => {
          this.showHandlerSnackbar({
            color: err.response.status,
            text: err.response.message,
            show: true,
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      followup: "followups/followup",
      priorities: "followups/priorities",
      necessaryDialog: "followups/necessaryDialog",
    }),
  },
};
</script>

<style>
</style>